import { useState } from 'react';
import ModalFull from '../../../methods/modal/modalFull/ModalFull';
import Image from '../../modals/image/Image';
import './imageCart.css';

export default function ImageCart({ item }) {
  const [modal, setModal] = useState(false);
  return (
    <>
      {modal && (
        <ModalFull
          onClicked={() => setModal(false)}
          height="h-full"
          width="w-full"
          View={() => (
            <Image onClicked={() => setModal(false)} pos="left" item={item} />
          )}
        />
      )}
      <div className="p-3">
        <div className="simpleImage group w-56 h-52 md:h-64  cursor-pointer overflow-hidden relative">
          <img src={item.icon} alt="images" />

          <div
            onClick={() => setModal(true)}
            className="w-24 h-24 text-center rounded-full bg-secondary-400 cursor-pointer transform scale-0 group-hover:scale-100 transition-all  duration-500 ease-in-out transCenter centerXY text-lg text-primary-800 leading-4"
          >
            View <br /> Project
          </div>
        </div>
      </div>
    </>
  );
}
